import { Injectable } from '@angular/core';
import { WindowWrapper } from 'src/app/content-list-management/shared/wrappers/window-wrapper';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  constructor(private window: WindowWrapper) {}

  sendDqaEmail(): void {
    let cmsUrl = this.getCmsUrl();
    if (cmsUrl.includes('new')) {
      cmsUrl =
        this.getWindowOrigin() + ' (Headline: ' + this.getHeadline() + ')';
    }

    this.setDocumentLocationHref(
      'mailto:cwxaudienceresearch@citywire.co.uk?subject=' +
        encodeURIComponent('Add or amend person or company.') +
        '&body=First%20Name:%0D%0ALast%20Name:%0D%0ACompany:%0D%0ACountry:%0D%0AJob%20Title:%0D%0AEmail%20Address:%0D%0ASource%20CMS%20link:' +
        encodeURIComponent(cmsUrl) +
        '%0D%0ADigizine section number(s):%20%0D%0ALinkedIn%20URL%20(very%20useful%20if%20known):'
    );
  }

  private getCmsUrl(): string {
    return this.window.location.href;
  }

  private getWindowOrigin(): string {
    return this.window.location.origin;
  }

  private getHeadline(): string {
    const headlineElement = this.window.document.getElementById(
      'headlineTitleInput'
    ) as HTMLInputElement;
    return headlineElement ? headlineElement.value : '';
  }

  setDocumentLocationHref(href: string): void {
    this.window.document.location.href = href;
  }
}
